/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IPresentationListsMethods,
  PresentationListsService,
  ICreateCouponMethods,
  CreateCouponService,
  IGetCouponsMethods,
  GetCouponsService,
  IUpdateCouponMethods,
  UpdateCouponService,
} from "./components";

export type CreateDiscountPageServiceAgent = IHeaderMethods &
  IStaticPageContentMethods &
  IPresentationListsMethods &
  ICreateCouponMethods &
  IGetCouponsMethods &
  IUpdateCouponMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new PresentationListsService(),
    new CreateCouponService(),
    new GetCouponsService(),
    new UpdateCouponService(),
  ];
};

export const getAgent = () => {
  return createAgent<CreateDiscountPageServiceAgent>({
    plugins: getPlugins(),
  });
};
